import classNames from 'classnames';
import { StaticImage } from 'gatsby-plugin-image';

import Button from '~components/Button/Button';
import RetirableListIcon from '~images/inline/retirable-list-icon.inline.svg';

type Props = {
    image?: string;
    title?: string;
    description?: string;
    listitem1?: string;
    listitem2?: string;
    listitem3?: string;
    listitem4?: string;
    showbanner?: string;
    ctacopy?: string;
    backgroundsurface?: SupportedBackgroundColor;
};
const RetirablePerksOffer = ({
    image = './images/retire.png',
    title = 'A special VIPerks offer',
    description = 'Members receive a consultation with a financial advisor and a comprehensive retirement plan — for FREE!',
    listitem1 = 'Timing advice for Social Security, pensions and retirement accounts.',
    listitem2 = 'Current and expected healthcare costs throughout retirement.',
    listitem3 = 'Where to tax-efficiently place funds while working and in retirement.',
    listitem4 = 'What is safe to spend each month in retirement.',
    showbanner = 'show',
    ctacopy = 'Learn more',
    backgroundsurface = 'bg-surface-100',
}: Props) => {
    return (
        <section className={classNames('px-4 py-6 md:py-10 lg:py-20', backgroundsurface)}>
            <div className="max-w-1200 mx-auto md:flex lg:items-center">
                <div className="shrink-0 flex flex-col items-center pb-6 md:pb-0">
                    <img
                        className="w-[246px] h-[246px] rounded-full mx-auto lg:w-[438px] lg:h-[438px]"
                        src={image}
                        alt=""
                    />
                </div>
                <div className="md:pl-12">
                    <div className="flex flex-col items-center border-b border-gray-outline">
                        {showbanner === 'show' && (
                            <div>
                                <StaticImage src="./images/ribbon.svg" alt="" loading="lazy" />
                            </div>
                        )}
                        <p className="text-24 leading-32 font-poppins font-bold text-link-visited pt-2 pb-3 md:text-32 md:leading-40 lg:text-40 lg:leading-56">
                            {title}
                        </p>
                    </div>
                    <div>
                        <div className="mb-6 mt-10 flex flex-col items-center">
                            <StaticImage
                                src="./images/ehealth-retirable.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <p className="text-18 leading-28 font-bold text-center lg:text-24 lg:leading-32">
                            {description}
                        </p>
                        <ul className="pt-6 lg:pl-12">
                            <li className="flex text-18 leading-28">
                                <RetirableListIcon className="shrink-0" />
                                <span className="ml-3">{listitem1}</span>
                            </li>

                            <li className="flex text-18 leading-28 pt-4">
                                <RetirableListIcon className="shrink-0" />
                                <span className="ml-3">{listitem2}</span>
                            </li>

                            <li className="flex text-18 leading-28 pt-4">
                                <RetirableListIcon className="shrink-0" />
                                <span className="ml-3">{listitem3}</span>
                            </li>

                            <li className="flex text-18 leading-28 pt-4">
                                <RetirableListIcon className="shrink-0" />
                                <span className="ml-3">{listitem4}</span>
                            </li>
                        </ul>
                        <div className="mt-6">
                            <Button
                                styletype="primary"
                                className="w-full md:w-[332px] mx-auto"
                                islink={true}
                                to="https://retirable.com/partners/ehealth?utm_source=medicare&utm_medium=web&utm_campaign=ehealth&utm_term=eperks"
                                data-wa-link="Retirable Perk: Learn More Retirable"
                            >
                                {ctacopy}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RetirablePerksOffer;
